import type { AuditCategory } from '@/types/portal';

/** Each category's icon and colours on the timeline (node, and the day header's count chip). */
export const CATEGORY_LOOK: Record<AuditCategory, { icon: string; node: string; chip: string }> = {
  Money: { icon: 'ri-money-dollar-circle-line', node: 'bg-accent-100 text-accent-700', chip: 'bg-accent-100 text-accent-800' },
  Access: { icon: 'ri-key-2-line', node: 'bg-secondary-100 text-secondary-800', chip: 'bg-secondary-100 text-secondary-900' },
  Campaign: { icon: 'ri-megaphone-line', node: 'bg-primary-100 text-primary-700', chip: 'bg-primary-100 text-primary-800' },
  Config: { icon: 'ri-settings-3-line', node: 'bg-background-200 text-foreground-700', chip: 'bg-background-200 text-foreground-700' },
  Security: { icon: 'ri-shield-keyhole-line', node: 'bg-foreground-900 text-background-50', chip: 'bg-foreground-900 text-background-50' },
};
